__turbopack_context__.v({
  "button": "processing-module-scss-module__tGDCPG__button",
  "icon": "processing-module-scss-module__tGDCPG__icon",
  "processing": "processing-module-scss-module__tGDCPG__processing",
  "title": "processing-module-scss-module__tGDCPG__title",
});
